const MapLoaded = (state = false, action) => {
    switch (action.type) {
        case  'MAP_LOADED':
            return action.payload;
    }
    return state
}

export default MapLoaded;



// WEBPACK FOOTER //
// ./src/reducers/MapLoaded.js